import { useEffect, useState } from "react";
import defaultDiaryImage from "../../Assets/images/noordiary2025.svg";
import { useNavigate } from "react-router-dom";
import { getNoorDiary } from "./_request";
import { websiteUrl } from "../../const/constants";




const toUrduDigits = (num) => {
  return num?.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]) || "";
};

const NoorDiaryHighlights = ({ diary }) => {
  const [diaryData, setDiaryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const fetchDiaryData = async () => {
    setLoading(true);
    try {
      const response = await getNoorDiary();
      if (response.Result) {
        const latestDiary = response.Diaries.reduce((latest, current) => {
          return parseInt(current.diary.year) >
            parseInt(latest?.diary?.year || 0)
            ? current
            : latest;
        }, null);
        setDiaryData(latestDiary?.diary || null);
      }
    } catch (error) {
      console.error("Error fetching diary data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!diary) {
      fetchDiaryData();
    }
  }, [diary]);

  const selectedDiary = diary || diaryData;

  const handleSeeMoreNoor = () => {
    navigate("/tableeghat/noordiary");
  };

  const getHijriYearRange = (gregorianYear) => {
    if (!gregorianYear) return "۱۴۴۷-۱۴۴۶";
    const hijriYear =
      parseInt(gregorianYear) -
      622 +
      Math.floor((parseInt(gregorianYear) - 622) / 32);
    return `${toUrduDigits(hijriYear)}-${toUrduDigits(hijriYear + 1)}`;
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return defaultDiaryImage;
    if (imagePath.startsWith("http")) return imagePath;
    return `${websiteUrl}/diaryImages/${imagePath.replace(/^\//, "")}`;
  };

  const getPdfUrl = (pdfPath) => {
    if (!pdfPath) return null;
    if (pdfPath.startsWith("http")) return pdfPath;
    return `${websiteUrl}/diaryPdf/${pdfPath.replace(/^\//, "")}`;
  };

  const handleViewPdf = () => {
    if (selectedDiary?.pdf) {
      setIsModalOpen(true);
    }
  };

  const handleDownloadPdf = async () => {
    if (selectedDiary?.pdf) {
      try {
        const pdfUrl = getPdfUrl(selectedDiary.pdf);
        const response = await fetch(pdfUrl, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch PDF: ${response.statusText}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `NoorDiary_${selectedDiary.year}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // Clean up
      } catch (error) {
        console.error("Error downloading PDF:", error);
        // Optional: Show user-friendly error message, e.g., alert('Failed to download PDF. Please try again.');
      }
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  if (loading || !selectedDiary) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
      </div>
    );
  }

  const hijriYears = getHijriYearRange(selectedDiary?.year);
  const pdfUrl = getPdfUrl(selectedDiary?.pdf);

  return (
    <div className=" rounded-3xl">
      <div
        onClick={handleSeeMoreNoor}
        className="flex flex-col-reverse lg:flex-row-reverse items-center justify-between gap-6 w-full h-full cursor-pointer"
      >
        {/* Text Content */}
        <div className="text-right flex flex-col py-8 sm:py-10 md:py-12 px-5 sm:px-10 md:px-10 lg:px-[4rem]">
          <div>
            <p
              dir="ltr"
              className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-2xl lg:text-4xl mb-4 max-w-[470px] mx-auto lg:mx-0"
            >
              {hijriYears}&#8202;&#8202;&#8202;&#8202;&#8202;&#8202;نورڈائری
            </p>
            <p className="tracking-[0.1rem] text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqRegular max-w-[470px] mx-auto lg:mx-0">
              ایسوسی ایشن آف مشتاقانِ نور ہر سال تعارف امام زمانہ علیہ السلام کے
              عنوان سے نور ڈائری کا اجرا کرتی ہے۔ الحمد للہ یہ کام گزشتہ کئی
              سالوں سے برادران کے علمی مطالعہ اور کوششوں سے جاری ہے۔
              <br></br>
              نور ڈائری کا مقصد و ہدف ان عام ڈائریوں سے مختلف ہے جو صرف روز مرہ کی ضروری باتیں نوٹ کرنے کے لئے شائع کی جاتی ہیں۔ 
               نور ڈائری کے دو بڑے مقاصد ہیں اولا محاسبہ نفس اور ثانیا معرفت امام زمانہ علیہ السلام۔
            </p>
          </div>
          {selectedDiary?.pdf && (
            <div className="flex justify-end gap-5 mt-4" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={handleViewPdf}
                className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary-dark transition-all duration-300"
              >
                View PDF
              </button>
              <button
                onClick={handleDownloadPdf}
                className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-secondary-dark transition-all duration-300"
              >
                Download PDF
              </button>
            </div>
          )}
        </div>
        {/* Image */}
        <div className="w-full    lg:w-1/2 flex justify-center lg:justify-start ml-32">
          <img
            src={getImageUrl(selectedDiary?.image)}
            alt={`Diary ${
              toUrduDigits(selectedDiary?.year) || "\u06f2\u06f0\u06f2\u06f5"
            }`}
            className="max-h-40 md:max-h-72 object-contain rounded-lg md:mr-10 "
            onError={(e) => {
              e.target.src = defaultDiaryImage;
            }}
            loading="lazy"
          />
        </div>
      </div>

      {/* PDF Modal */}
      {isModalOpen && pdfUrl && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-11/12 md:w-3/4 lg:w-1/2 max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center p-4 border-b">
              <h2 className="text-xl font-nastaleeqKasheeda">
                نور ڈائری {toUrduDigits(selectedDiary?.year)}
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                &times;
              </button>
            </div>
            <div className="p-4">
              <iframe
                src={pdfUrl}
                className="w-full h-[70vh]"
                title={`Noor Diary ${selectedDiary?.year} PDF`}
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoorDiaryHighlights;
